<div [ngClass]="schedulerSettings?.isPaused?'status-content-paused':'status-content'">
    <span *ngIf="schedulerSettings?.isPaused" class="pause-label" title="{{schedulerSettings.pauseInfo}}">Paused
        until: {{schedulerSettings.pauseEndStr}}</span>
    <mat-icon [ngClass]="getStatusClass()">fiber_manual_record</mat-icon>
    <span class="status-label">{{getStatusText()}}</span>
</div>
